// extracted by mini-css-extract-plugin
export default {"wrapper":"messages-indicator_wrapper__yVPR3","opacity-transition":"messages-indicator_opacity-transition__oHz-W"};